export const OPEN_STATUS = {
  ANY: 0,
  OPEN: 1,
  CLOSED_PERMANENTLY: 2,
  CLOSED_TEMPORARILY: 3
};
